export default {
  reports: {
    usersByStatus: "Usuários por Status",
    usersByGender: "Usuários por Gênero",
    avgAreaPerUnit: "Área Média em {unit}",
    yieldPerUnit: "Rendimento por {unit}",
    listByYield: "Lista por Rendimento",
    gen: "Gênero",
    gender: "Gráfico de Gênero",
    unspefied: "Não Especificado",
    byCountry: "Por País",
    avgPriceFarmer: "Preço Médio Pago por Agricultor (Cacau)",
    avgPrice: "Preço Médio",
    selectYear: "Selecionar Ano",
    total: "Total",
    today: "Hoje",
    week: "Semana",
    month: "Mês",
    year: "Ano",
    all: "Todos",
    selectCrop: "Selecionar Cultura",
    selectRegion: "Selecionar Região",
    selectProvinceState: "Selecionar Província/Estado",
    downloadPdfReport: "Baixar Relatório em PDF",
    export: "Exportar",
    search: "Pesquisar",
    yield: "Rendimento",
    averageSellingPriceByAllFarmers:
      "Preço Médio de Venda por Todos os Agricultores",
    averageSellingPricePerFarmer: "Preço Médio de Venda por Agricultor",
    pricePaid: "Preço Pago",
    dashboard: {
      topCharts: "Principais Gráficos",
      regions: "Regiões",
      noOfFarms: "Número de Fazendas/Região",
      provinces: "Províncias/Estados",
      landArea: "Área de Terreno",
      avgFarmerLand: "Terreno Médio por Agricultor",
      viewAll: "Ver Todos",
      crops: "Culturas",
      plantedAreaCrop: "Área Plantada/Cultura",
      plantedArea: "Área Plantada",
      avgYieldCrop: "Rendimento Médio/Cultura",
      averageYield: "Rendimento Médio",
      yieldChart: "Gráfico de Rendimento",
      selectFarm: "Selecionar Fazenda",
      soilQuality: "Qualidade do Solo",
      pests: "Pragas",
      occurrences: "Ocorrências",
      equipments: "Equipamentos",
      goalAchievedChart: "Gráfico de Metas Alcançadas",
      soilValues: "Valores do Solo",
      soil: "Solo",
      showReport: "Mostrar relatórios no Painel",
      selectAll: "Selecionar Tudo",
    },
    weight: "Peso",
    quality: "Qualidade",
    price: "Preço",

    male: "Masculino",
    female: "Femenino",
    other: "Outros",
    farmerName: "Nome do agricultor",
    farmerProdChart: "Gráfico de Produção do Agricultor",
    production: "Produção",
    byProduction: "Por Produção",
    byName: "Por nome",
    descending: "Decrescente",
    ascending: "Crescente",
    buyingStationProdChart: "Gráfico de Produção da Estação de Coleta",
    buyingStation: "Estação de coleta",
    buyingStationName: "Nome da estação de coleta",
    dryMilling: "Moagem a Seco",
    dryMillingName: "Nome de moagem a seco",
    dryMillingProdChart: "Tabela de Produção de Moagem a Seco",
    view: "Visualizar",
    date: "Encontro",
    reports: "Relatórios",
    pests: {
      pestReport: "Relatório de Pragas",
      filterByCrops: "Filtrar por Culturas",
      pestStatistics: "Estatísticas de Pragas",
      regions: "Regiões",
      occurrences: "Ocorrências",
      pestChart: "Gráfico de Pragas",
      totalArea: "Área Total",
      pestName: "Nome da Praga",
      region: "Região",
      crop: "Culturas",
      listByLand: "Listar por Terreno",
    },
    regions: {
      regionalReport: "Relatório Regional",
      listByFarm: "Lista por Fazenda",
      listByFarmers: "Lista por Agricultores",
      listByYield: "Lista por Rendimento",
      regionalStatistics: "Estatísticas Regionais",
      countries: "Países",
      states: "Estados/Províncias",
      city: "Cidade/Vila",
      farmsIn: "Fazendas em",
      regionalChart: "Gráfico Regional",
      farms: "Fazendas",
      regionName: "Nome da Região",
      farmers: "Agricultores",
      yield: "Rendimento/Acre",
    },
  },
}
